import axios from './axios'

export const register = (data) => {
  return axios({
    url: '/api/user/register',
    method: 'post',
    data
  })
}
export const industryAll = (data) => {
  return axios({
    url: '/api/industry/getAll',
    method: 'get',
    params: data
  })
}
//工业云获取第三方
// /api/platform/third/getRecommendThirdList
export const thirdgetList = (data) => {
  return axios({
    url: '/api/platform/third/getList',
    method: 'get',
    params: data
  })
}
// register、login、resetPassword
export const getSmsCode = (data) => {
  return axios({
    url: '/api/user/getSmsCode',
    method: 'post',
    data
  })
}

export const passwordLogin = (data) => {
  return axios({
    url: '/api/user/passwordLogin',
    method: 'post',
    data
  })
}

export const smsLogin = (data) => {
  return axios({
    url: '/api/user/smsLogin',
    method: 'post',
    data
  })
}

export const resetPasswordSmsCode = (data) => {
  return axios({
    url: '/api/user/resetPasswordSmsCode',
    method: 'post',
    data
  })
}

export const resetPassword = (data) => {
  return axios({
    url: '/api/user/resetPassword',
    method: 'post',
    data
  })
}
// 获取主题颜色和头部图片
export const getWebsite = (data) => {
  return axios({
    url: '/api/platformWebsite/getWebsite',
    method: 'get',
    params: data
  })
}

export const getBanner = (data) => {
  return axios({
    url: '/api/platform/getBanner',
    method: 'get',
    params: data
  })
}
export const getNumber = (data) => {
  return axios({
    url: '/api/platform/getNumber',
    method: 'get',
    params: data
  })
}

export const getNews = (data) => {
  return axios({
    url: '/api/platform/getNews',
    method: 'get',
    params: data
  })
}

export const getCompanyLogo = (data) => {
  return axios({
    url: '/api/platform/getCompanyLogo',
    method: 'get',
    params: data
  })
}

//产品分类
export const getProdCategoryAll = (data) => {
  return axios({
    url: '/api/category/getAll',
    method: 'get',
    params: data
  })
}
//一级分类
export const getFirstList = (data) => {
  return axios({
    url: '/api/category/getFirstList',
    method: 'get',
    params: data
  })
}
//二级分类
export const getSecondList = (data) => {
  return axios({
    url: '/api/category/getSecondList',
    method: 'get',
    params: data
  })
}
//首页推荐产品
export const getRecommendList = (data) => {
  return axios({
    url: '/api/prod/getRecommendList',
    method: 'get',
    params: data
  })
}

export const getCompanyRecommendList = (data) => {
  return axios({
    url: '/api/company/getRecommendList',
    method: 'get',
    params: data
  })
}
//首页推荐新技术/产品/服务
export const getRecommendSvrAndTechList = (data) => {
  return axios({
    url: '/api/svr/getRecommendSvrAndTechList',
    method: 'get',
    params: data
  })
}
//首页推荐云在线
export const getRecommendOlList = (data) => {
  return axios({
    url: '/api/ol/getRecommendOlList',
    method: 'get',
    params: data
  })
}
//首页推荐代理商经销商
export const getRecommendCooperateList = (data) => {
  return axios({
    url: '/api/demand/getRecommendCooperateList',
    method: 'get',
    params: data
  })
}
//首页推荐人才招聘
export const getRecommendRecruitmentList = (data) => {
  return axios({
    url: '/api/hr/getRecommendRecruitmentList',
    method: 'get',
    params: data
  })
}
//首页推荐活动展会会议
export const getRecommendActList = (data) => {
  return axios({
    url: '/api/act/getRecommendActList',
    method: 'get',
    params: data
  })
}
//企业列表
export const getCompanyList = (data) => {
  return axios({
    url: '/api/company/getList',
    method: 'get',
    params: data
  })
}
//获得企业详情
export const getCompanyDetail = (data) => {
  return axios({
    url: '/api/company/getDetail',
    method: 'get',
    params: data
  })
}
//获得企业应用程序列表
export const getCompanyApplicationCoList = (data) => {
  return axios({
    url: '/api/companyApplication/getCoList',
    method: 'get',
    params: data
  })
}

//获得企业荣誉证书列表
export const getCompanyHonerCoList = (data) => {
  return axios({
    url: '/api/companyHoner/getCoList',
    method: 'get',
    params: data
  })
}

//获得企业动态(分类列表)
export const getCompanyCoListForType = (data) => {
  return axios({
    url: '/api/companyNews/getCoListForType',
    method: 'get',
    params: data
  })
}

//获得企业产品与服务
export const getCompanyCoProdAndSvr = (data) => {
  return axios({
    url: '/api/prod/getCoProdAndSvr',
    method: 'get',
    params: data
  })
}
//获取服务列表
export const getSvrList = (data) => {
  return axios({
    url: '/api/svr/getSvrList',
    method: 'get',
    params: data
  })
}
//获得企业资料中心
export const getCompanyCoLibraryCentre = (data) => {
  return axios({
    url: '/api/companyLibrary/getCoLibraryCentre',
    method: 'get',
    params: data
  })
}

//获得企业云工厂
export const getCompanyCoOlFactory = (data) => {
  return axios({
    url: '/api/ol/getCoOlFactory',
    method: 'get',
    params: data
  })
}

//获得企业在线项目/工程
export const getCompanyCoOlProject = (data) => {
  return axios({
    url: '/api/ol/getCoOlProject',
    method: 'get',
    params: data
  })
}

//获得企业新技术新产品
export const getCompanyCoTechList = (data) => {
  return axios({
    url: '/api/tech/getCoTechList',
    method: 'get',
    params: data
  })
}

//获得企业活动展会会议
export const getCompanyCoAct = (data) => {
  return axios({
    url: '/api/act/getCoAct',
    method: 'get',
    params: data
  })
}

//获得企业代理商经销商
export const getCompanyCoCooperate = (data) => {
  return axios({
    url: '/api/demand/getCoCooperate',
    method: 'get',
    params: data
  })
}

//获得企业采购招投标
export const getCompanyCoProcurement = (data) => {
  return axios({
    url: '/api/demand/getCoProcurement',
    method: 'get',
    params: data
  })
}

//获得企业人才招聘与团建
export const getCompanyCoHr = (data) => {
  return axios({
    url: '/api/hr/getCoHr',
    method: 'get',
    params: data
  })
}

//获得动态类型+统计列表
export const getNewsTypeList = (data) => {
  return axios({
    url: '/api/companyNews/getNewsTypeList',
    method: 'get',
    params: data
  })
}
//资讯news、公告notice
export const getNewsList = (data) => {
  return axios({
    url: '/api/platform/getNewsList',
    method: 'get',
    params: data
  })
}
//资讯详情
export const getNewsDetail = (data) => {
  return axios({
    url: '/api/platform/getNewsDetail',
    method: 'get',
    params: data
  })
}
//服务详情
export const getSvrDetail = (data) => {
  return axios({
    url: '/api/svr/getSvrDetail',
    method: 'get',
    params: data
  })
}
//企业动态列表
export const getCompanyNewsList = (data) => {
  return axios({
    url: '/api/companyNews/getList',
    method: 'get',
    params: data
  })
}

//产品列表
export const getProdList = (data) => {
  return axios({
    url: '/api/prod/getProdList',
    method: 'get',
    params: data
  })
}

//产品列表
export const getProdDetail = (data) => {
  return axios({
    url: '/api/prod/getDetail',
    method: 'get',
    params: data
  })
}

//云工厂列表
export const getFactoryList = (data) => {
  return axios({
    url: '/api/ol/getFactoryList',
    method: 'get',
    params: data
  })
}

//在线项目/工程列表
export const getProjectList = (data) => {
  return axios({
    url: '/api/ol/getProjectList',
    method: 'get',
    params: data
  })
}

//新技术新产品列表
export const getTechList = (data) => {
  return axios({
    url: '/api/tech/getTechList',
    method: 'get',
    params: data
  })
}


//代理商经销商招募列表
export const getCooperateList = (data) => {
  return axios({
    url: '/api/demand/getCooperateList',
    method: 'get',
    params: data
  })
}

//代理商经销商招募类型+统计列表
export const getCooperateTypeList = (data) => {
  return axios({
    url: '/api/demand/getCooperateTypeList',
    method: 'get',
    params: data
  })
}

//采购招投标列表
export const getProcurementList = (data) => {
  return axios({
    url: '/api/demand/getProcurementList',
    method: 'get',
    params: data
  })
}

//采购招投标类型+统计列表
export const getProcurementTypeList = (data) => {
  return axios({
    url: '/api/demand/getProcurementTypeList',
    method: 'get',
    params: data
  })
}

//人才招聘列表
export const getRecruitmentList = (data) => {
  return axios({
    url: '/api/hr/getRecruitmentList',
    method: 'get',
    params: data
  })
}

//人才招聘详情
export const getRecruitmentDetail = (data) => {
  return axios({
    url: '/api/hr/getRecruitmentDetail',
    method: 'get',
    params: data
  })
}

//企业团建列表
export const getBuildingList = (data) => {
  return axios({
    url: '/api/hr/getBuildingList',
    method: 'get',
    params: data
  })
}

//企业团建详情
export const getBuildingDetail = (data) => {
  return axios({
    url: '/api/hr/getBuildingDetail',
    method: 'get',
    params: data
  })
}

//活动展会会议列表
export const getActList = (data) => {
  return axios({
    url: '/api/act/getActList',
    method: 'get',
    params: data
  })
}

//活动展会会议类型+统计列表
export const getActTypeList = (data) => {
  return axios({
    url: '/api/act/getActTypeList',
    method: 'get',
    params: data
  })
}
//资料中心类型+数量统计
export const getLibraryType = (data) => {
  return axios({
    url: '/api/companyLibrary/getLibraryType',
    method: 'get',
    params: data
  })
}
//资料中心列表
export const getLibraryList = (data) => {
  return axios({
    url: '/api/companyLibrary/getLibraryList',
    method: 'get',
    params: data
  })
}

//首页推荐资料中心
export const getRecommendLibraryList = (data) => {
  return axios({
    url: '/api/companyLibrary/getRecommendLibraryList',
    method: 'get',
    params: data
  })
}

//类型，company企业、prod产品、tech新产品技术、ol_factory云工厂、
// ol_project在线项目/工厂、demand_cooperate代理商经销商招募、demand_procurement采购招投标、
// act活动/展会/会议、company_news企业动态、company_library资料中心、hr_recruitment人力资源
export const collectAdd = (data) => {
  return axios({
    url: '/api/user/collect/add',
    method: 'post',
    data
  })
}

export const collectCancel = (data) => {
  return axios({
    url: '/api/user/collect/cancel',
    method: 'post',
    data
  })
}

//收藏企业列表
export const getCollectCompanyList = (data) => {
  return axios({
    url: '/api/user/collect/getCompanyList',
    method: 'get',
    params: data
  })
}

//收藏产品列表
export const getCollectProdList = (data) => {
  return axios({
    url: '/api/user/collect/getProdList',
    method: 'get',
    params: data
  })
}

//收藏服务列表
export const collectgetSvrList = (data) => {
  return axios({
    url: '/api/user/collect/getSvrList',
    method: 'get',
    params: data
  })
}
//收藏资讯列表
export const getCollectNewsList = (data) => {
  return axios({
    url: '/api/user/collect/getNewsList',
    method: 'get',
    params: data
  })
}

//浏览企业列表
export const getBrowsingCompanyList = (data) => {
  return axios({
    url: '/api/user/browsing/getCompanyList',
    method: 'get',
    params: data
  })
}
//浏览商品列表
export const getBrowsingProdList = (data) => {
  return axios({
    url: '/api/user/browsing/getProdList',
    method: 'get',
    params: data
  })
}

//浏览咨询列表
export const getBrowsingNewsList = (data) => {
  return axios({
    url: '/api/user/browsing/getNewsList',
    method: 'get',
    params: data
  })
}
//修改手机号
export const modifyPhone = (data) => {
  return axios({
    url: 'api/user/modifyPhone',
    method: 'post',
    data
  })
}

//评论列表
//类型，prod产品、tech新产品技术、ol_factory云工厂、ol_project在线项目/工厂、
// demand_cooperate代理商经销商招募、demand_procurement采购招投标、act活动/展会/会议、
// company_news企业动态、hr_recruitment招聘 hr_building团建
export const getFeedbackById = (data) => {
  return axios({
    url: '/api/user/feedback/getById',
    method: 'get',
    params: data
  })
}
//评论操作
//类型，prod产品、tech新产品技术、ol_factory云工厂、ol_project在线项目/工厂、
// demand_cooperate代理商经销商招募、demand_procurement采购招投标、
// act活动/展会/会议、company_news企业动态、hr_recruitment招聘 hr_building团建
export const addFeedback = (data) => {
  return axios({
    url: '/api/user/feedback/feedback',
    method: 'post',
    data
  })
}

//删除评论
export const delFeedback = (data) => {
  return axios({
    url: '/api/user/feedback/delFeedback',
    method: 'post',
    data
  })
}
// 点赞
export const dzan = (data) => {
  return axios({
    url: '/api/user/feedback/feedbackFabulous',
    method: 'post',
    data
  })
}
//产品关联产品
export const getRelationProdList = (data) => {
  return axios({
    url: '/api/prod/getRelationProdList',
    method: 'get',
    params: data
  })
}
// 修改头像
export const modifyHead = (data) => {
  return axios({
    url: '/api/user/modifyHead',
    method: 'post',
    data
  })
}
//企业信息
export const getSimpleDetail = (data) => {
  return axios({
    url: '/api/company/getSimpleDetail',
    method: 'get',
    params: data
  })
}

//获得省份列表
export const getProvinceList = (data) => {
  return axios({
    url: '/api/sys/region/getProvinceList',
    method: 'get',
    params: data
  })
}

//未读的评论回复数量
export const unReadNum = (data) => {
  return axios({
    url: '/api/user/feedback/unReadNum',
    method: 'get',
    params: data
  })
}

//我的评论列表
export const userFeedbackList = (data) => {
  return axios({
    url: '/api/user/feedback/userFeedbackList',
    method: 'get',
    params: data
  })
}

//站内信列表
export const messageList = (data) => {
  return axios({
    url: '/api/user/message/messageList',
    method: 'get',
    params: data
  })
}
//已读站内信
export const messgeSign = (data) => {
  return axios({
    url: '/api/user/message/messgeSign',
    method: 'post',
    data
  })
}
// 删除站内信
export const messgeDelete = (data) => {
  return axios({
    url: '/api/user/message/messgeDelete',
    method: 'post',
    data
  })
}
//站内信未读数量
export const unReadNumMessage = (data) => {
  return axios({
    url: '/api/user/message/unReadNum',
    method: 'get',
    params: data
  })
}

//在线项目/工程详情
export const getProjectDetail = (data) => {
  return axios({
    url: '/api/ol/getProjectDetail',
    method: 'get',
    params: data
  })
}

//新技术新产品详情
export const getTechlDetail = (data) => {
  return axios({
    url: '/api/tech/getTechlDetail',
    method: 'get',
    params: data
  })
}

//代理商经销商招募详情
export const getCooperateDetail = (data) => {
  return axios({
    url: '/api/demand/getCooperateDetail',
    method: 'get',
    params: data
  })
}

//采购招投标详情
export const getProcurementDetail = (data) => {
  return axios({
    url: '/api/demand/getProcurementDetail',
    method: 'get',
    params: data
  })
}

//活动展会会议详情
export const getActDetail = (data) => {
  return axios({
    url: '/api/act/getActDetail',
    method: 'get',
    params: data
  })
}

//企业动态详情
export const getActionDetail = (data) => {
  return axios({
    url: '/api/companyNews/getDetail',
    method: 'get',
    params: data
  })
}

//企业动态详情
export const getThirdList = (data) => {
  return axios({
    url: '/api/platform/third/getList',
    method: 'get',
    params: data
  })
}

//咨询或者寻求合作 1咨询2寻求合作
// prod产品、tech新产品技术、ol_factory云工厂、ol_project在线项目/工厂、demand_cooperate代理商经销商招募、demand_procurement采购招投标、act活动/展会/会议、company_news企业动态、hr_recruitment招聘
export const addAdvice = (data) => {
  return axios({
    url: '/api/user/advice/add',
    method: 'post',
    data
  })
}

// 获得企业联系人
export const ContactgetAll = (data) => {
  return axios({
    url: '/api/companyContact/getAll',
    method: 'get',
    params: data
  })
}

export const getNavigationList = (data) => {
  return axios({
    url: '/api/platformWebsite/getNavigationList',
    method: 'get',
    params: data
  })
}

export const getCompanyTodayViews = (data) => {
  return axios({
    url: '/api/applest/statis/getCompanyTodayViews',
    method: 'get',
    params: data
  })
}

export const getCompanytotalViews = (data) => {
  return axios({
    url: '/api/applest/statis/getCompanytotalViews',
    method: 'get',
    params: data
  })
}

export const getChartViews = (data) => {
  return axios({
    url: '/api/applest/statis/getChartViews',
    method: 'get',
    params: data
  })
}

export const getIndustry = (data) => {
  return axios({
    url: '/api/applest/statis/getIndustry',
    method: 'get',
    params: data
  })
}

export const getCategory = (data) => {
  return axios({
    url: '/api/applest/statis/getCategory',
    method: 'get',
    params: data
  })
}

export const getRanking = (data) => {
  return axios({
    url: '/api/applest/statis/getRanking',
    method: 'get',
    params: data
  })
}
export const getFeedback = (data) => {
  return axios({
    url: '/api/applest/statis/getFeedback',
    method: 'get',
    params: data
  })
}
// 获取分享签名、appid等信息
export const getWechat = (data) => {
  return axios({
    url: '/api/wechat/getJsapiTicketNonceStr',
    method: 'post',
    data
  })
}
//样本资质统计
export const saveStatsLibrary = (data) => {
  return axios({
    url: '/api/companyLibrary/saveStatsLibrary',
    method: 'post',
    data
  })
}
// 邀请码验证
export const checkInviteCode = (data) => {
  return axios({
    url: `/api/ol/checkInviteCode/${data.id}/${data.inviteCode}`,
    method: 'get',
    // data
  })
}

//企业宣传片浏览量
export const addUserBrowsingCompany = (data) => {
  return axios({
    url: '/api/companyVideo/addUserBrowsingCompany',
    method: 'post',
    data
  })
}

// 5.8点击企业相关页面，记录相关记录信息

//企业宣传片浏览量
export const clickPageAbuotEnterprise = (data) => {
  return axios({
    url: '/api/pageRecord/clickPageAbuotEnterprise',
    method: 'post',
    data
  })
}

// 扫码进入统计
export const addShareConversion = (data) => {
  return axios({
    url: '/statsShareConversion/addShareConversion',
    method: 'post',
    data: {
      ...data
    }
  })
}


// WEBPACK FOOTER //
// ./src/api/method.js